import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const uploadURLAPI = createApi({
    reducerPath: "uploadURLAPI",
    baseQuery: fetchBaseQuery({ baseUrl: "/" }), // Replace '/' with your actual base URL
    endpoints: (builder) => ({
        sendUploadURL: builder.mutation({
            query: ({ body, url }) => ({
                url, // Ensure url is a relative path if baseQuery is used
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const { useSendUploadURLMutation } = uploadURLAPI;
